import type { ReactNode } from "react";

const DecDeWidthContainer = ({ children }: { children: ReactNode }) => (
  <div className="decde-width-container">{children}</div>
);

export { DecDeWidthContainer };
